export default __webpack_public_path__ + "static/media/config-teams-illustration.c89c7717.svg";